import { Button } from "@/components/ui/button";
import { ArrowLeft, BookOpen, ArrowRight } from "@phosphor-icons/react";
import Image from "next/legacy/image";
import DummyLogo from "@/assets/images/lucidity-placeholder.png";
import { useRouter } from "next/router";
import LockedContent from "./LockedContent";
import Link from "next/link";
import { useState } from "react";

function ProfileLogo({ src, alt }) {
  const [imgSrc, setImgSrc] = useState(src || DummyLogo);

  return (
    <Image
      src={imgSrc}
      alt={alt}
      layout='fill'
      className='object-contain'
      onError={() => setImgSrc(DummyLogo)}
    />
  );
}

function MentionedVCAndStartup({ pinneds, width, locked, isLogin }) {
  const router = useRouter();

  return (
    (pinneds?.startups?.length > 0 || pinneds?.ventureCapitals?.length > 0) && (
      <div
        className={`${width ? "w-full" : "max-w-[65ch]"} mx-auto text-white`}
      >
        <h2 className='pb-4 text-lg font-semibold border-b lg:text-2xl border-white/10'>
          Mentioned Startup & VC Profiles
        </h2>
        <div className='flex flex-wrap gap-4 mt-6'>
          {pinneds &&
            [
              ...(pinneds.startups || []).map((item) => ({
                ...item,
                isStartup: true,
              })),
              ...(pinneds.ventureCapitals || []).map((item) => ({
                ...item,
                isStartup: false,
              })),
            ].map((item) => {
              const profileUrl = item.isStartup
                ? `/startups/${item.slug}-${item.id}`
                : `/investors/${item.slug}-${item.id}`;
              const category = item.isStartup ? "Startup" : "VC";

              return (
                <Link
                  href={profileUrl}
                  title={item.summary}
                  className='relative flex flex-col items-center w-28 p-3 pb-4 transition-colors border rounded-lg lg:w-32 group border-white/10 hover:border-white/30 hover:bg-white/5'
                  key={`${item.isStartup ? "s" : "vc"}-${item.id}`}
                >
                  {/* Logo */}
                  <div className='relative flex-shrink-0 p-1 overflow-hidden bg-white rounded-lg size-14 lg:size-16'>
                    <ProfileLogo src={item.logo_url} alt={item.name} />
                  </div>
                  {/* Name */}
                  <p className='mt-3 text-xs font-medium leading-snug text-center lg:text-sm line-clamp-2'>
                    {item.name}
                  </p>
                  {/* Badge */}
                  <span className='inline-flex px-2.5 py-0.5 mt-2 text-[10px] font-semibold text-white rounded-full bg-gradient-to-tr from-yellow-1 to-red-1'>
                    {category}
                  </span>
                </Link>
              );
            })}
        </div>
      </div>
    )
  );
}

export default MentionedVCAndStartup;
